import { z } from 'zod';
export const zodShards = {
    text: z
        .string({
        error: 'Required field',
    })
        .transform((value) => value.trim())
        .refine((value) => value.length >= 2, { message: 'Required field' }),
    date: z.string().refine((value) => /\d{4}-\d{2}-\d{2}/.test(value), { message: 'Please enter correct date' }),
    document: z.object({
        files: z.array(z.any()),
        is_no_document: z.boolean(),
        reason: z.string().optional(),
    }),
    email: z
        .string({ error: 'Email is required, e.g. name@example.com' })
        .check(z.email({ error: 'Please enter correct email' })),
};
//# sourceMappingURL=shards.js.map